<template>
  <div id="app">
  <div class="container">
    <div class="row">
          <div class="col-sm-1 col-md-1 col-lg-1"></div>
          <div class="col-xs-12 col-sm-10 col-md-10 col-lg-10">
              <nav class="navbar navbar-default" role="navigation">
                  <div class="container-fluid">
                      <div class="navbar-header">
                          <button type="button" class="navbar-toggle" data-toggle="collapse"
                                  data-target="#example-navbar-collapse">
                              <span class="sr-only">切换导航</span>
                              <span class="icon-bar"></span>
                              <span class="icon-bar"></span>
                              <span class="icon-bar"></span>
                          </button>
                          <a class="navbar-left" href="http://www.afkplayer.com"><img src="./assets/logo.png" style="width:150px;height:50px;" alt="AFKPlayer"></a>
                      </div>
                      <div class="collapse navbar-collapse" id="example-navbar-collapse">
                          <ul class="nav navbar-nav">
                              <li class="active"><a href="#">首页</a></li>
                              <li><a href="#">日志</a></li>
                              <li class="dropdown">
                              <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                                  小工具<b class="caret"></b>
                              </a>
                              <ul class="dropdown-menu">
                                  <li><a href="#">单位转换</a></li>
                                  <li><a href="#">日期计算</a></li>
                                  <li><a href="#">个税计算器</a></li>
                                  <li class="divider"></li>
                                  <li><a href="#">其它功能</a></li>
                                  <li class="divider"></li>
                                  <li><a href="#">其它功能2</a></li>
                              </ul>
                              </li>
                          </ul>
                          <ul class="nav navbar-nav navbar-right"> 
                              <li><a href="#"><span class="glyphicon glyphicon-user"></span> 注册</a></li> 
                              <li><a href="#"><span class="glyphicon glyphicon-log-in"></span> 登录</a></li> 
                          </ul> 
                      </div>
                      
                  </div>
              </nav>
          </div> 
          <div class="col-sm-1 col-md-1 col-lg-1"></div>   
      </div>

      <div class="row content">
          <div class="container">
              <div class="row">
                  <div class="col-sm-1 col-md-1 col-lg-1"></div>   
                  <div class="col-xs-12 col-sm-10 col-md-10 col-lg-10">
                      <div class="jumbotron">
                        
                        <IPBoard></IPBoard>
                      </div>
                  </div>
                  <div class="col-sm-1 col-md-1 col-lg-1"></div>
              </div>
              <div class="row">
                  <div class="col-sm-1 col-md-1 col-lg-1"></div>   
                  <div class="col-xs-12 col-sm-10 col-md-10 col-lg-10">
                      <div class="jumbotron">
                          <div class="container">
                              <div id="app-danwei">
                                  <h3>单位换算</h3>
                                  <br>
                                  <br>
                                  <ul id="myTab" class="nav nav-tabs">
                                      <li class="active"> <a href="#length" data-toggle="tab">长度</a></li>
                                      <li><a href="#area" data-toggle="tab">面积</a></li>
                                      <li><a href="#volume" data-toggle="tab">体积</a></li>
                                      
                                  </ul>
                                  <div id="myTabContent" class="tab-content">
                                      <div class="tab-pane fade in active" id="length">
                                          <br>
                                          <UnitConvertor :units="lengthUnits"></UnitConvertor>
                                      </div>
                                      <div class="tab-pane fade" id="area">
                                          <br>
                                          <UnitConvertor :units="areaUnits"></UnitConvertor>
                                      </div>
                                      <div class="tab-pane fade" id="volume">
                                          <br>
                                          <p class="text-center">敬请期待。。。</p>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-sm-1 col-md-1 col-lg-1"></div>
              </div>
          </div>
      </div>

      <div class="row footer">
          <div class="container">
              <div class="row">
                  <div class="col-xs-12">
                      <p class="text-center">Copyright@2019 Powered by afkplayer.com</p>
                      <p class="text-center"><a href="http://www.beian.miit.gov.cn/" target="_blank">蜀ICP备19004170号</a></p>
                  </div>
              </div>
          </div>
      </div>
  </div>
  </div>
</template>

<script>
import IPBoard from './components/IPBoard.vue'
import UnitConvertor from './components/UnitConvertor.vue'

export default {
  name: 'app',
  data: function() {
    return {
      client: {
        wanip:''
      },
      lengthUnits: {},
      areaUnits: {}
    }
  },
  created: function() {
    this.getUnits()
  },
  methods: {
    getUnits: function(){
      this.areaUnits = {
        'commonUnit':3,
        'list':[
          {'short': 'km²', 'text': '平方千米', 'value':1000000000000},
          {'short': 'ha', 'text': '公顷', 'value':10000000000},
          {'short': 'are', 'text': '公亩', 'value':100000000},
          {'short': 'm²', 'text': '平方米', 'value':1000000},
          {'short': 'dm²', 'text': '平方分米', 'value':10000},
          {'short': 'cm²', 'text': '平方厘米', 'value':100},
          {'short': 'mm²', 'text': '平方毫米', 'value':1},
          {'short': 'sq.mi', 'text': '平方英里', 'value':645.16 * 144 * 27878400},
          {'short': 'sq.ft', 'text': '平方英尺', 'value':645.16 * 144},
          {'short': 'sq.in', 'text': '平方英寸', 'value':645.16},
          {'short': 'sq.yd', 'text': '平方码', 'value':645.16 * 1296},
          {'short': 'sq.rd', 'text': '平方杆', 'value':645.16 * 39204},
          {'short': 'acre', 'text': '英亩', 'value':645.16 * 39204 * 160},
          {'short': '', 'text': '顷', 'value':111111.1111111 * 600 * 10 * 100},
          {'short': '', 'text': '亩', 'value':111111.1111111 * 600 * 10},
          {'short': '', 'text': '分', 'value':111111.1111111 * 600},
          {'short': '', 'text': '平方尺', 'value':111111.1111111},
          {'short': '', 'text': '平方寸', 'value':1111.11111111},
        ]
      }
      this.lengthUnits = {
        'commonUnit':1,
        'list':[
          {'short': 'km', 'text': '千米', 'value':1000000},
          {'short': 'm', 'text': '米', 'value':1000},
          {'short': 'dm', 'text': '分米', 'value':100},
          {'short': 'cm', 'text': '厘米', 'value':10},
          {'short': 'mm', 'text': '毫米', 'value':1},
          {'short': 'mi', 'text': '英里', 'value':25.4 * 12 * 5280},
          {'short': 'ft', 'text': '英尺', 'value':25.4 * 12},
          {'short': 'in', 'text': '英寸', 'value':25.4},
          {'short': '', 'text': '里', 'value':500000},
          {'short': '', 'text': '丈', 'value':500000 / 150},
          {'short': '', 'text': '尺', 'value':500000 / 1500},
          {'short': '', 'text': '寸', 'value':500000 / 15000},
          {'short': '', 'text': '分', 'value':500000 / 150000},
          {'short': '', 'text': '厘', 'value':500000 / 1500000},
        ]
      }
    }
  },
  components: {
    IPBoard,
    UnitConvertor
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>
